interface PlaybackRateOption {
  rate: number;
  decimals: number;
}

export const playbackRateOptions: PlaybackRateOption[] = [
  { rate: 0.25, decimals: 2 },
  { rate: 0.5, decimals: 1 },
  { rate: 0.75, decimals: 2 },
  { rate: 1, decimals: 1 },
  { rate: 1.25, decimals: 2 },
  { rate: 1.5, decimals: 1 },
  { rate: 1.75, decimals: 2 },
  { rate: 2, decimals: 0 },
  { rate: 2.5, decimals: 1 },
  { rate: 3, decimals: 0 },
  { rate: 3.5, decimals: 1 },
  { rate: 4, decimals: 0 },
];

export const getDefaultVideoPlayerOptions = () => {
  return {
    autoplay: false,
    controls: false,
    responsive: true,
    fill: true,
    withCredentials: false,
    inactivityTimeout: 3000,
    preload: "auto",
    playsinline: true,
    // crossorigin omitted on purpose — most public MP4s don't send CORS
    // headers, and forcing "anonymous" makes them fail to load. Frame capture
    // / canvas features won't work without it; re-enable per-source if needed.
  };
};
